import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { profileService } from "../../services";
import { permissions, ROLES } from "../../constants";

export const fetchPermissions = createAsyncThunk(
    "permissions/fetchPermissions",
    async (role, { rejectWithValue }) => {
        try {
            if (role === ROLES.DRIVER) {
                const driverPermissions = permissions
                    .filter((perm) =>
                        ["VIEW_APPOINTMENTS", "ADD_APPOINTMENTS", "CHANGE_APPOINTMENT_STATUS"].includes(perm.name)
                    )
                    .map((perm) => perm.name);
                return driverPermissions;
            } else if (role !== ROLES.ADMIN) {
                const { success, data } = await profileService.fetchRolePermissions();
                if (success && data?.permissions) {
                    return data.permissions.map((perm) => perm.name);
                } else if (success === false) {
                    return permissions.map((perm) => perm.name);
                }
                return rejectWithValue("Failed to fetch permissions");
            } else {
                return permissions.map((perm) => perm.name);
            }
        } catch (error) {
            if (error.response?.status === 404) {
                return permissions.map((perm) => perm.name);
            }
            return rejectWithValue(error.message);
        }
    }
);

const permissionsSlice = createSlice({
    name: "permissions",
    initialState: {
        data: [],
        status: "idle",
        error: null,
        loginKey: 0,
    },
    reducers: {
        clearPermissions: (state) => {
            state.data = [];
            state.status = "idle";
            state.error = null;
        },
        updateLoginKey: (state) => {
            state.loginKey += 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPermissions.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchPermissions.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
                state.loginKey += 1;
            })
            .addCase(fetchPermissions.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { clearPermissions, updateLoginKey } = permissionsSlice.actions;
export default permissionsSlice.reducer;
